<template>
  <div>
    <div class="title-top-alarm">
      <div><span>患病情况</span></div>
      <div class="line-title"></div>
    </div>
    <div style="min-height: 100px;margin: 20px 40px;text-align: center">
      <div v-if="isEditMsg || isCallBack">
        <span>患病类型：</span>
        <el-cascader v-fixZoom style="width: 425px" :options="diseasesnew" v-model="selectdiseasesids" :filterable="true" placeholder="请选择病种"
                     :props="{ disabled: 'disabled', multiple: true, checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                     ref="disease" @change="changeDisease"></el-cascader>
        <div v-if="otherDisease" style="margin-top: 10px">
          <el-input placeholder="请输入其他疾病" v-model="input_disease"></el-input>
        </div>
        <div style="margin: 20px 0;height: 60px">
          <el-row style="margin: 0 80px">
            <el-col :span="12">
              <div class="cancel-btn" @click="closeOpen()"><span>取消</span></div>
            </el-col>
            <el-col :span="12">
              <div class="send-btn" @click="submit()"><span>确定</span></div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else>
        <el-tag type="danger" v-for="item in diseaseids" :key="item.index" style="margin-left: 10px">{{getDiseaseName(item)}}</el-tag>
        <el-tag type="danger" v-if="input_disease !== ''">{{input_disease}}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'diseaseSelect',
  model: {
    prop: 'diseaseShow',
    event: 'change'
  },
  props: {
    diseaseObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isEditMsg: false,
      isCallBack: false,
      diseasenames: [],
      diseasesnew: [],
      selectdiseasesids: [],
      diseaseids: [],
      input_disease: '',
      otherDisease: false
    }
  },
  created () {
    // 1、serviceObjectAlarm.vue 2、oldPerson.vue 3、checkMsg.vue
    this.isEditMsg = this.diseaseObj.isEditMsg
    this.isCallBack = this.diseaseObj.isCallBack
    this.diseasenames = this.diseaseObj.diseasenames
    this.diseasesnew = this.clone(this.diseaseObj.diseasesnew)
    this.selectdiseasesids = this.diseaseObj.selectdiseasesids
    this.diseaseids = this.diseaseObj.diseaseids
    this.input_disease = this.diseaseObj.input_disease
    this.diseasesnew.push({id: -1, name: '其他疾病'})
    if (this.input_disease !== '') {
      this.selectdiseasesids.push(-1)
      this.otherDisease = true
    }
  },
  methods: {
    getDiseaseName (id) {
      // console.log(id)
      for (let i = 0; i < this.diseasenames.length; i++) {
        if (parseInt(id) === this.diseasenames[i].id) {
          return this.diseasenames[i].name
        }
      }
    },
    changeDisease (ids) {
      console.log(ids)
      let id = -1
      if (this.selectdiseasesids.indexOf(id) > -1) {
        this.otherDisease = true
      } else {
        this.otherDisease = false
      }
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submit () {
      let ids = this.selectdiseasesids
      let aa = '' // 患病id字符串
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] !== -1) {
          if (aa === '') {
            aa = ids[i] + ''
          } else {
            aa = aa + ',' + ids[i]
          }
        }
      }
      if (this.otherDisease && this.input_disease === '') {
        this.$message({
          message: '请输入其他疾病。',
          type: 'warning'
        })
        return
      }
      let obj = {
        have_disease: aa,
        input_disease: this.input_disease
      }
      this.$emit('changeDiseaseObj', obj)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/handlealarm/childComponents/diseaseSelect.vue